import React from "react";
import "./Records.css";
import PathologyRecord from "./RecordsSidebar/RecordsMain/PathologyRecord";
import PrescriptionRecord from "./RecordsSidebar/RecordsMain/PrescriptionRecord";
import RadiologyRecord from "./RecordsSidebar/RecordsMain/RadiologyRecord";
import VaccinationRecord from "./RecordsSidebar/RecordsMain/VaccinationRecord";
import HospitalizationReccord from "./RecordsSidebar/RecordsMain/HospitalizationRecord";
import MedicalCertificateRecord from "./RecordsSidebar/RecordsMain/MedicalCertificateRecord";
import { useParams, useNavigate } from "react-router-dom";
import { useApp } from "./../../../AppProvider";

const Records = () => {
  const { patientsMHR } = useApp();
  const navigate = useNavigate();
  let { recordId } = useParams();

  // If no data or empty list → Show "Record Not Found"
  if (!patientsMHR || patientsMHR.length === 0) {
    return <div className="records-data-not-found">Record Not Found!</div>;
  }

  if (recordId === undefined) {
    recordId = patientsMHR[0].recordId;
    navigate(`/DashboardDashboardNavigation/records/${recordId}`);
  }

  const record = patientsMHR.find(item => item.recordId === recordId);
  if (record.typeOfRecord === "PathologyRecord") {
    return <PathologyRecord />;
  } else if (record.typeOfRecord === "PrescriptionRecord") {
    return <PrescriptionRecord />;
  } else if (record.typeOfRecord === "RadiologyRecord") {
    return <RadiologyRecord />;
  } else if (record.typeOfRecord === "VaccinationRecord") {
    return <VaccinationRecord />;
  } else if (record.typeOfRecord === "HospitalizationReccord") {
    return <HospitalizationReccord />;
  } else if (record.typeOfRecord === "MedicalCertificateRecord") {
    return <MedicalCertificateRecord />;
  } else {
    return <PathologyRecord />;
  }
};

export default Records;
